import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  MenuItem,
  TextField,
  createMuiTheme, DialogActions, Button, Box, Typography, FormGroup,
  IconButton, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction,
  List, ListItem, DialogContent, DialogTitle, Dialog, FormControlLabel, Checkbox,
  TableContainer, Table, TableBody, TableRow, TableCell, TableHead, CardActions
} from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import moment from 'moment';
// import 'moment/locale/vi'
import 'moment/min/locales';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import EventNoteIcon from '@material-ui/icons/EventNote';
import { getUser } from 'src/utils/Common';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { setTask } from '../../store/actions/taskActions';


const useStyles = makeStyles(theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  cardsMax: {
    maxHeight: 750,
    minHeight: 750
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};

function Scheduling({ className, ReceiptNo, readonly, tasks, setTask }) {

  const { t } = useTranslation('work_order');
  const messages = {
    allDay: t('lblDaytime'),
    previous: t('lblPrevious'),
    next: t('lblNext'),
    today: t('lblToday'),
    month: t('lblMonth'),
    week: t('lblWeek'),
    day: t('lblDay'),
    agenda: t('lblAgenda'),
    date: t('lblDate'),
    time: t('lblTime'),
    event: t('lblEvent'), // Or anything you want
    showMore: total => `+ ${total}` + t('lblAdditionalEvents')
  }

  const classes = useStyles();
  const SessionUser = getUser();
  const locale = localStorage.getItem('i18nextLng');
  if (locale === 'vn') {
    moment.locale('vi');
  } else {
    moment.locale(locale);
  }


  // moment.locale('vi');




  const localizer = momentLocalizer(moment);
  const [ServiceShopData, setServiceShopData] = useState([]);
  const [EmployeeData, setEmployeeData] = useState([]);
  const [ServiceShopId, setServiceShopId] = useState(0);
  const [ConsumerAddressId, setConsumerAddressId] = useState(0);
  const [SchedulingPopup, setSchedulingPopup] = useState(false);
  const [EmployeeId, setEmployeeId] = useState(0);
  const [AppointmentDateEvent, setAppointmentDateEvent] = useState([]);
  const [SchedulingData, setSchedulingData] = useState([]);
  const [TechnicianSchedulingData, setTechnicianSchedulingData] = useState([]);
  const [DisabledControl, setDisabledControl] = useState(false);
  const [ServiceShopSelected, setServiceShopSelected] = useState(null);
  const [ServiceShopCapacitySelected, setServiceShopCapacitySelected] = useState(true)



  var SonlandirData = tasks.tasks.filter(d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));


  const today = new Date()

  const [noAppointmentDate, setNoAppointmentDate] = useState(false)

  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      setDisabledControl(true);
    }
  }, [SessionUser.Role]);

  useEffect(() => {
    if (AppointmentDateEvent.length === 0 && SonlandirData[0]?.AppointmentDate != undefined && SonlandirData[0]?.AppointmentEndDate != undefined) {
      // changeAppointment(SonlandirData[0].AppointmentDate, SonlandirData[0].AppointmentEndDate)
    }
  }, [AppointmentDateEvent]);

  const GetSchedulingServiceShop = (ConsumerId, AddressId) => {
    setServiceShopData([]);
    setServiceShopId('');
    axios
      .get(`/GetSchedulingServiceShop/${ConsumerId}/${AddressId}/${ReceiptNo}/${SessionUser.Role}`)
      .then(response => {
        if (response.data.length > 0) {
          var ServiceShopList = response.data;
          setServiceShopData(ServiceShopList);
          if (ServiceShopList.length === 1 && parseInt(SonlandirData[0]?.ServiceShopId || 0) < 1) {
            // setServiceShopId(ServiceShopList[0].Id);
            GetSchedulingEmployee(ServiceShopList[0].Id);
            return;
          }

          if (parseInt(SonlandirData[0]?.ServiceShopId || 0) > 0) {
            setServiceShopId(SonlandirData[0]?.ServiceShopId);
            var ServisData = ServiceShopList.filter(x => x.Id === SonlandirData[0]?.ServiceShopId);
            setServiceShopSelected(ServisData[0]);
            GetSchedulingEmployee(SonlandirData[0]?.ServiceShopId);
          }

        }
      })
      .catch(error => { });
  };

  const GetSchedulingEmployee = ServiceShopId => {
    setEmployeeData([]);
    setEmployeeId('');
    axios
      .get(`/GetSchedulingEmployee/${ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          var EmloyeeList = response.data;
          setEmployeeData(EmloyeeList);
          if (SonlandirData[0]?.EmployeeId || 0 > 0) {
            // let job = SonlandirData[0];
            // job = {
            //   ...job,
            //   EmployeeId: SonlandirData[0]?.EmployeeId,
            //   ServiceShopId: ServiceShopId
            // };
            // setTask(job);
            setEmployeeId(SonlandirData[0]?.EmployeeId);
          } else {
            // let job = SonlandirData[0];
            // job = {
            //   ...job,
            //   EmployeeId: EmloyeeList[0]?.Id,
            //   ServiceShopId: ServiceShopId
            // };
            // setTask(job);
            // setEmployeeId(EmloyeeList[0]?.Id);
          }

          const TechnicianData = response.data.filter(
            d => parseInt(d.Id) === parseInt(SonlandirData[0].EmployeeId)
          );
          const AppointmentH = [];
          TechnicianData[0].Appointment.forEach(item => {
            const App1 = new Date(item.start);
            const App2 = new Date(item.end);

            AppointmentH.push({
              title: item.title,
              start: App1,
              end: App2,
              MobileStatusId: item.MobileStatusId
            });
          });

          if (AppointmentH.length > 0) {
            setAppointmentDateEvent(AppointmentH);
          }
        } else {
          let job = SonlandirData[0];
          job = {
            ...job,
            ServiceShopId: ServiceShopId
          };
          setTask(job);
        }

      })
      .catch(error => { });
  };

  useEffect(() => {
    if (SonlandirData[0]?.ConsumerId && SonlandirData[0]?.ConsumerAddressId) {
      GetSchedulingServiceShop(
        SonlandirData[0].ConsumerId,
        SonlandirData[0].ConsumerAddressId
      );
      setConsumerAddressId(SonlandirData[0].ConsumerAddressId);
    }

  }, [SonlandirData[0]?.ConsumerId]);

  const handleChangeWorkOrderAddressId = event => {
    let job = SonlandirData[0];
    job = {
      ...job,
      ConsumerAddressId: event.target.value
    };
    setTask(job);
    setConsumerAddressId(event.target.value);
    GetSchedulingServiceShop(SonlandirData[0].ConsumerId, event.target.value);
  };

  const handleChangeServiceShopId = value => {
    setServiceShopSelected(value);
    setServiceShopId(value.Id);
    GetSchedulingEmployee(value.Id);
    let job = SonlandirData[0];
    job = {
      ...job,
      ServiceShopId: value.Id
    };
    setTask(job);
  };


  const handleChangeEmployeeId = event => {
    setEmployeeId(event.target.value);
    const TechnicianData = EmployeeData.filter(
      d => parseInt(d.Id) === parseInt(event.target.value)
    );
    const AppointmentH = [];
    TechnicianData[0].Appointment.forEach(item => {
      const App1 = new Date(item.start);
      const App2 = new Date(item.end);
      AppointmentH.push({
        title: item.title,
        start: App1,
        end: App2,
        MobileStatusId: item.MobileStatusId
      });
    });
    setAppointmentDateEvent(AppointmentH);
    let job = SonlandirData[0];
    job = {
      ...job,
      EmployeeId: event.target.value
    };
    setTask(job);
  };

  const changeAppointmentDate = ({ start, end }) => {
    changeAppointment(start, end)
  }

  function changeAppointment(start, end) {
    if (!noAppointmentDate) {
      const DateValue = moment(start).format('YYYY.MM.DD HH:mm');
      const EndDateValue = moment(end).format('YYYY.MM.DD HH:mm')
      let job = SonlandirData[0];
      job = {
        ...job,
        AppointmentDate: DateValue,
        AppointmentEndDate: EndDateValue
      };
      const AppointmentH = [...AppointmentDateEvent];
      const filteredIndex = AppointmentH.findIndex(
        x => x.title === `WO:${ReceiptNo}`
      );
      if (filteredIndex > -1) {
        AppointmentH.splice(filteredIndex, 1);
      }
      AppointmentH.push({
        title: `WO:${ReceiptNo}`,
        start: new Date(DateValue),
        end: new Date(EndDateValue)
      });
      setAppointmentDateEvent(AppointmentH);
      setTask(job);
    }
  }

  const setPreferredDate = value => {
    const DateValue = moment(value).format('YYYY.MM.DD HH:mm');
    let job = SonlandirData[0];
    job = {
      ...job,
      PreferredDate: DateValue,
    };
    setTask(job);
  };


  const setAppointmentData = value => {

    const DateValue = moment(value).format('YYYY.MM.DD HH:mm');
    const EndDateValue = moment(value).add(2, 'hours').format('YYYY.MM.DD HH:mm');
    let job = SonlandirData[0];
    job = {
      ...job,
      AppointmentDate: DateValue,
      AppointmentEndDate: EndDateValue
    };
    const AppointmentH = [...AppointmentDateEvent];
    const filteredIndex = AppointmentH.findIndex(
      x => x.title === `WO:${ReceiptNo}`
    );
    if (filteredIndex > -1) {
      AppointmentH.splice(filteredIndex, 1);
    }

    AppointmentH.push({
      title: `WO:${ReceiptNo}`,
      start: new Date(DateValue),
      end: new Date(EndDateValue)
    });

    setAppointmentDateEvent(AppointmentH);
    setTask(job);
  };

  const setAppointmentEndData = value => {
    const DateValue = moment(value).format('YYYY.MM.DD HH:mm');
    let job = SonlandirData[0];
    job = {
      ...job,
      AppointmentEndDate: DateValue
    };
    const AppointmentH = [...AppointmentDateEvent];
    const filteredIndex = AppointmentH.findIndex(
      x => x.title === `WO:${ReceiptNo}`
    );
    if (filteredIndex != -1) {
      AppointmentH.splice(filteredIndex, 1);
      AppointmentH.push({
        title: `WO:${ReceiptNo}`,
        start: new Date(SonlandirData[0].AppointmentDate),
        end: new Date(DateValue)
      });
    }
    else {
      AppointmentH.push({
        title: `WO:${ReceiptNo}`,
        start: new Date(SonlandirData[0].AppointmentDate),
        end: new Date(DateValue)
      });
    }

    setAppointmentDateEvent(AppointmentH);
    setTask(job);
  };


  const handleClickschedulingOpen = (event) => {
    axios.get(`GetServiceShopScheduling/${ServiceShopId}`)
      .then((response) => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setSchedulingData(Deger);
        } else {
          var Control = [{ AppointmentDate: 'No appointment', WorkOrderCount: 0 }];
          setSchedulingData(Control);
        }
      }).catch((error) => {

      });

    axios.get(`GetTechnicianScheduling/${EmployeeId}`)
      .then((response) => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setTechnicianSchedulingData(Deger);
        } else {
          var Control = [{ AppointmentDate: 'No appointment', WorkOrderCount: 0 }];
          setTechnicianSchedulingData(Control);
        }
      }).catch((error) => {

      });
    setSchedulingPopup(true);
  }

  function setToNoAppointmentDate() {
    let job = SonlandirData[0];
    if (!noAppointmentDate) {
      const AppointmentH = [...AppointmentDateEvent];
      const filteredIndex = AppointmentH.findIndex(
        x => x.title === `WO:${ReceiptNo}`
      );
      job = {
        ...job,
        AppointmentDate: null,
        AppointmentEndDate: null,
        noAppointmentDate:!noAppointmentDate
      };
      if (filteredIndex !== -1) {
        AppointmentH.splice(filteredIndex, 1);
        setAppointmentDateEvent(AppointmentH);
        
      }
    }
    setTask(job);
    setNoAppointmentDate(!noAppointmentDate)
  }

  function eventStyleGetter(event) {
    var backgroundColor = '#19a3ff'
    if (event.MobileStatusId && event.MobileStatusId > 0) {
      if (event.MobileStatusId === 5) {
        backgroundColor = '#bf261b'
      }
      else if (event.MobileStatusId === 22) {
        backgroundColor = '#9615d1'
      }
      else if (event.MobileStatusId === 33) {
        backgroundColor = '#18c718'
      }
      else if (event.MobileStatusId === 42) {
        backgroundColor = '#ff9500'
      }
      else {
        backgroundColor = '#8c8c8c'
      }
    }


    var style = {
      backgroundColor: backgroundColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block'
    };
    return {
      style: style
    };
  }


  return (
    <Card className={classes.cardsMax}>
      <CardHeader title={t('lblScheduling')} />
      <Divider />
      <CardContent className={classes.content}>
        <div className={classes.fields}>
          <FormControl variant="outlined" className={classes.formControl}>
            <TextField
              size="small"
              fullWidth
              select
              label={t('lblAddress')}
              id="WorkOrderAddressId"
              onChange={handleChangeWorkOrderAddressId}
              value={ConsumerAddressId}
              variant="outlined"
            >
              {SonlandirData[0]?.Addresses ? SonlandirData[0].Addresses.map(p => {
                return (
                  <MenuItem key={p.AddressId} value={p.AddressId}>
                    {p.Address}
                    {p.PrimaryAddress === true ? ` - ${t('lblPrimary')}` : ''}
                  </MenuItem>
                );
              }) : null}
            </TextField>
          </FormControl>
        </div>
        <div className={classes.fields}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={5} lg={5}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
              >
                <Autocomplete
                  size="small"
                  fullWidth
                  autoSelect
                  disableClearable
                  disabled={DisabledControl}
                  value={ServiceShopSelected || null}
                  options={ServiceShopData || []}
                  getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                  getOptionSelected={(option, value) => option.Id === value.Id}
                  renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined"
                  />}
                  onChange={(event, value) => { handleChangeServiceShopId(value); }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDateTimePicker
                    color="primary"
                    fullWidth
                    size="small"
                    disabled={noAppointmentDate || SonlandirData[0]?.MobileStatusId == 42}
                    ampm={false}
                    inputVariant="outlined"
                    label={t('AppointmentDate')}
                    invalidDateMessage={t('hatali_tarih')}
                    format="dd.MM.yyyy HH.mm"
                    variant="outlined"
                    value={
                      SonlandirData[0]?.AppointmentDate ? SonlandirData[0].AppointmentDate : null
                    }
                    onChange={e => setAppointmentData(e)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={1} lg={1} align={'center'}>
              <Box p={0}>
                <IconButton color="primary"
                  onClick={(event) => handleClickschedulingOpen(event)} className={classes.info}>
                  <EventNoteIcon />
                </IconButton>
              </Box>
            </Grid>
            <Grid item xs={12} sm={3} lg={3} align={'center'}>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    control={<Checkbox color="primary"
                      checked={noAppointmentDate}
                      onChange={() => setToNoAppointmentDate()}
                    />}
                    label={t("lblNoAppointmentDate")}
                    labelPlacement="end"
                    checked={noAppointmentDate}
                  />
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        </div>
        <div className={classes.fields}>
          <FormControl variant="outlined" className={classes.formControl}>
            <TextField
              size="small"
              fullWidth
              select
              label={t('lblEmployee')}
              id="EmployeeId"
              onChange={handleChangeEmployeeId}
              value={EmployeeId}
              variant="outlined"
            >
              {EmployeeData.map(p => {
                return (
                  <MenuItem key={p.Id} value={p.Id}>
                    {p.Dsc}
                  </MenuItem>
                );
              })}
            </TextField>
          </FormControl>
        </div>
        <div className={classes.fields}>
          <FormControl variant="outlined" className={classes.formControl}>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDateTimePicker
                  color="primary"
                  fullWidth
                  size="small"
                  ampm={false}
                  inputVariant="outlined"
                  id="PreferredDate"
                  // disablePast
                  label={t('lblPreferredDate')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy HH.mm"
                  variant="outlined"
                  value={
                    SonlandirData[0]?.PreferredDate ? SonlandirData[0].PreferredDate : ''
                  }
                  onChange={e => setPreferredDate(e)}
                  disabled={SessionUser.Role === 3 ? false : true}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </FormControl>
        </div>
        <br />
        <Calendar
          selectable
          onSelectEvent={event => alert(event.title)}
          localizer={localizer}
          messages={messages}
          events={AppointmentDateEvent}
          defaultView={Views.WEEK}
          toolbar
          step={60}
          min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 0)}
          style={{ height: 400 }}
          onSelectSlot={changeAppointmentDate}
          eventPropGetter={eventStyleGetter}
        />
      </CardContent>
      <Dialog
        open={SchedulingPopup}
        onClose={() => setSchedulingPopup(false)}
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblScheduling')}</DialogTitle>
        <br></br>
        <Divider></Divider>
        <br></br>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={1} lg={1} />
          <Grid item xs={5} sm={5} lg={5}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => setServiceShopCapacitySelected(true)}
              style={ServiceShopCapacitySelected ? { backgroundColor: '#13d426' } : {}}
            >
              {t('lblService')}
            </Button>
          </Grid>
          <Grid item xs={5} sm={5} lg={5}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => setServiceShopCapacitySelected(false)}
              style={!ServiceShopCapacitySelected ? { backgroundColor: '#13d426' } : {}}
            >
              {t('lblTechnician')}
            </Button>
          </Grid>
          <Grid item xs={1} sm={1} lg={1} />
          <Divider></Divider>
        </Grid>
        <br></br>
        {
          ServiceShopCapacitySelected ?
            <DialogContent>
              {SchedulingData.map((row, index) => (
                <Card>
                  <CardHeader
                    title={moment(row.AppointmentDate).format('DD/MM/YYYY')}
                    subheader={<Typography variant="h6">
                      {t('lblTotalWork') + ' : ' + row.WorkOrderCount}
                    </Typography>}
                  />
                  <CardContent>
                    <Table
                      stickyHeader
                      aria-labelledby="tableTitle"
                      size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            {t('lblTimeSlot')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCapacity')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblWorkCount')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row?.TimeSlotCapacity?.map((item, index) => (
                          <TableRow key={item.index}
                            style={{
                              backgroundColor:
                                item?.WorkCount > item.Capacity ? 'tomato' :
                                  (item?.WorkCount === item.Capacity ? '#AFEEEE' :
                                    '#CCFFCC')
                            }}
                          >
                            <TableCell align="left">
                              {item.TimeSlot}
                            </TableCell>
                            <TableCell align="left">
                              {item.Capacity}
                            </TableCell>
                            <TableCell align="left">
                              {item?.WorkCount}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              ))}
            </DialogContent> :
            <DialogContent>
              {TechnicianSchedulingData.map((row, index) => (
                <Card>
                  <CardHeader
                    title={moment(row.AppointmentDate).format('DD/MM/YYYY')}
                    subheader={<Typography variant="h6">
                      {t('lblTotalWork') + ' : ' + row.WorkOrderCount}
                    </Typography>}
                  />
                  <CardContent>
                    <Table
                      stickyHeader
                      aria-labelledby="tableTitle"
                      size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            {t('lblTimeSlot')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCapacity')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblWorkCount')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row?.TimeSlotCapacity?.map((item, index) => (
                          <TableRow key={item.index}
                            style={{
                              backgroundColor:
                                item?.WorkCount > item.Capacity ? 'tomato' :
                                  (item?.WorkCount === item.Capacity ? '#AFEEEE' :
                                    '#CCFFCC')
                            }}
                          >
                            <TableCell align="left">
                              {item.TimeSlot}
                            </TableCell>
                            <TableCell align="left">
                              {item.Capacity}
                            </TableCell>
                            <TableCell align="left">
                              {item?.WorkCount}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              ))}
            </DialogContent>

        }

        <DialogActions>
          <Button
            onClick={() => setSchedulingPopup(false)}
            color="primary"
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Scheduling.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(Scheduling);
